import { type DomainAccessControlConfig } from 'domains/retailer-collections/utils/domain/accessControl'
import { Permission } from 'domains/retailer-collections/access-control/permissions'
import { Flipper } from 'domains/retailer-collections/access-control/flippers'

export const retailerCollectionsV2AccessControl: DomainAccessControlConfig = {
  warehouseFlippers: [Flipper.retailerCollectionsV2],
  permissions: [Permission.Admin],
}
